import { render, staticRenderFns } from "./vip-phone-bind.vue?vue&type=template&id=49ed468e&scoped=true&"
import script from "./vip-phone-bind.vue?vue&type=script&lang=js&"
export * from "./vip-phone-bind.vue?vue&type=script&lang=js&"
import style0 from "./vip-phone-bind.vue?vue&type=style&index=0&id=49ed468e&scoped=true&lang=less&"
import style1 from "./vip-phone-bind.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ed468e",
  null
  
)

export default component.exports